import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Inject, Input, LOCALE_ID, OnInit, Optional, Output, TemplateRef, ViewChild } from '@angular/core';
import { TypeConverter } from '@farris/ide-property-panel';
import { DatagridComponent } from '@farris/ui-datagrid';
import { PickedResult } from '@farris/ui-lookup';
import { MessagerService } from '@farris/ui-messager';
import { Observable, of } from 'rxjs';
import { ProcessDesignerUIState } from '../../app/process-designer.uistate';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../i18n/assets/lang.resource';
import { DisplayInfor, OtherAssignActivityNodeInfo } from './other-assign-activity-node-info';
import { DialogComponent } from '@farris/ui-dialog';
import { EditorTypes } from '@farris/ui-datagrid-editors';
import { ExprEditMode, ExpressionService, InjectedType, VarEntity } from '@gsp-svc/expression';

@Component({
  selector: 'lib-assign-scope',
  templateUrl: './assign-scope.component.html',
  styleUrls: ['./assign-scope.component.scss'],
  providers: [
     WfLocalePipe,
  ]
})
export class AssignScopeComponent implements OnInit, AfterViewInit {

  @Output() closeModal = new EventEmitter<any>();
  @Output() submitModal = new EventEmitter<any>();
  @ViewChild('iconSelectFooter') modalFooter: TemplateRef<any>;
  @ViewChild('grid') grid: DatagridComponent;
  @ViewChild('actionsTable1') actionsTable1: DatagridComponent;
  @ViewChild('actionsDialog1') actionsDialog1: DialogComponent;

  @Input() editorParams: any = {};
  @Input() set value(data) {
    if (data && data.length > 0) {
      // this.otherAssignActivities = [...data];
      data.forEach(data1 =>{
        let otherAssignActivityNodeInfo = new OtherAssignActivityNodeInfo(data1.activityDefinitionId, data1.condition ? data1.condition.Value : data1.condition, data1.required);
        this.otherAssignActivityNodeInfos.push(otherAssignActivityNodeInfo);
      } );
      this.otherAssignActivityNodeInfos.forEach(other =>{
        let displayInfo = new DisplayInfor(null,other.activityDefinitionId);
        displayInfo.required = other.required;
        if(other.condition){
          displayInfo.condition = other.condition.Value;
        }
        // displayInfo.name = this.items.find(item => item.Id === displayInfo.activityDefinitionId).Name;
        this.listItems.push(displayInfo);
      } );
    }
  }

  location;

  items = new Array();

  listItems = new Array<DisplayInfor>();

  modalConfig = {
    title: this.localePipe.transform('component.assignScope.assignScopeList'),
    width: 600,
    height: 520,
    showButtons: true
  };

  cols = [
    { title: this.localePipe.transform('component.assignScope.name'), field: 'name', width: 80},
    { title: 'ID', field: 'activityDefinitionId', width: 100},
    { title: this.localePipe.transform('component.assignScope.required'), field: 'required', width: 50,
      editor: {
        type: EditorTypes.SWITCH,
        options: {}
      },
      formatter: { type: 'boolean', options: { trueText: this.localePipe.transform('component.assignScope.yes'), falseText: this.localePipe.transform('component.assignScope.no') } },
      validators: [
        { type: 'required', messager: '必填' }
      ]
    },
    { title: this.localePipe.transform('component.assignScope.condition'), field: 'condition', width: 70,
      editor: {
        type: 'input-group',
        options: {
          groupText: '<i class="f-icon f-icon-lookup"></i>',
          editable: false,
          clickHandle: (e) => {
            e.formControl.setValue(e.instance.value ? e.instance.value : '');
            this.editConditon(e);
          },
          clear: (e) => {
            console.log('clear', e);
          }
        }
      }
    }
  ];

  nodeCols = [
    { title: this.localePipe.transform('component.assignScope.name'), field: 'Name', width: 100, filter: true },
    { title: 'ID', field: 'Id', width: 100, filter: true },
  ]

  // otherAssignActivities = new Array();

  otherAssignActivityNodeInfos = new Array<OtherAssignActivityNodeInfo>();

  curActivity;

  constructor(
    private uistate: ProcessDesignerUIState,
    private message: MessagerService,
    private exprService: ExpressionService,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe,
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
   }

  ngOnInit() {
    if (!this.location) {
      this.location = this.editorParams.location;
    }
    let activities = new Array();
    if (this.location === 'startActivity') {
      activities = [...this.uistate.userActList.filter(a => a.Id !== this.uistate.propertyData.Id
        && a.AssignmentStrategy === 'ASSIGN'
        && a.AssignPerformerConfig
        && a.AssignPerformerConfig.Operator === 'procInstCreator')];
    } else {
      activities = [...this.uistate.userActList.filter(a => a.Id !== this.uistate.propertyData.Id && a.AssignmentStrategy === 'ASSIGN')];
    }

    this.items = activities;

    let outArray = [];

    this.listItems.forEach(listItem => {
      if(this.items.find(item => item.Id === listItem.activityDefinitionId)) {
        listItem.name = this.items.find(item => item.Id === listItem.activityDefinitionId).Name;
      }else {
        outArray.push(listItem);
      }
    });

    this.listItems = this.listItems.filter(listItem => outArray.every(out => out.activityDefinitionId !== listItem.activityDefinitionId));
  }


  ngAfterViewInit(): void {
    if (this.otherAssignActivityNodeInfos && this.otherAssignActivityNodeInfos.length > 0) {
      for (const other of this.otherAssignActivityNodeInfos) {
        this.grid.checkRow(other.activityDefinitionId);
      }
    }
  }

  delete() {
    this.grid.endCellEdit();
    if (this.grid.selectedRow && this.grid.selectedRow.data) {
      const i = this.listItems.findIndex(d => d.activityDefinitionId === this.grid.selectedRow.data.activityDefinitionId);
      this.listItems.splice(i, 1);
      this.grid.loadData(this.listItems);
    } else {
      this.message.info(this.localePipe.transform('component.assignScope.deleteRow'));
    }
  }

  moveUp() {
    if (!this.curActivity) {
      this.message.info(this.localePipe.transform('component.assignScope.curActivity'));
      return;
    }
    const curCmpId: string = this.curActivity.activityDefinitionId;
    const i = this.listItems.findIndex(c => c.activityDefinitionId === curCmpId);
    if (i === 0) {
      return;
    }
    this.swapArray(this.listItems, i, i - 1);

    this.grid.loadData(this.listItems);
    this.grid.selectRow(curCmpId, true);

    // const selectedRow = this.grid.selectedRow;
    // debugger;
    // if (!selectedRow) {
    //   this.message.info('尚未选中行');
    //   return;
    // }
    // if (selectedRow.index === 0) {
    //   return;
    // }
    // this.swapArray(this.items, selectedRow.index, selectedRow.index - 1);

    // this.grid.loadData(this.items);
    // this.grid.selectRow(selectedRow.id, true);
  }

  moveDown() {
    if (!this.curActivity) {
      this.message.info(this.localePipe.transform('component.assignScope.curActivity'));
      return;
    }
    const curCmpId: string = this.curActivity.activityDefinitionId;
    const i = this.listItems.findIndex(c => c.activityDefinitionId === curCmpId);
    if (i === this.listItems.length - 1) {
      return;
    }
    this.swapArray(this.listItems, i, i + 1);

    this.grid.loadData(this.listItems);
    this.grid.selectRow(curCmpId, true);


    // const selectedRow = this.grid.selectedRow;
    // if (!selectedRow) {
    //   this.message.info('尚未选中行');
    //   return;
    // }
    // if (selectedRow.index === this.items.length - 1) {
    //   return;
    // }
    // this.swapArray(this.items, selectedRow.index, selectedRow.index + 1);

    // this.grid.loadData(this.items);
    // this.grid.selectRow(selectedRow.id, true);
  }

  selectionChange(data: any) {
    this.curActivity = data.data;
  }

  private swapArray(arr: Array<any>, i1: number, i2: number): Array<any> {
    arr[i1] = arr.splice(i2, 1, arr[i1])[0];
    return arr;
  }

  clickOK() {
    this.grid.endCellEdit();
    this.otherAssignActivityNodeInfos = new Array();
    for (const item of this.listItems) {
      this.otherAssignActivityNodeInfos.push(new OtherAssignActivityNodeInfo(
        item.activityDefinitionId, item.condition, item.required));
    }
    const object = { value: this.otherAssignActivityNodeInfos, parameters: null };
    this.submitModal.emit(object);
  }

  clickCancel() {
    this.closeModal.emit();
  }

  actionsDialogShow() {
    this.actionsDialog1.show();
    if(this.actionsTable1 && this.listItems) {
      let itemIds = this.listItems.map(item => {
        return item.activityDefinitionId;
      })
      this.actionsTable1.checkRows(itemIds);
    }
  }

  actionsSelect() {
    const selections: any[] = this.actionsTable1.checkeds;
    let addAlreadyHas = false;
    if (selections && selections.length > 0) {
      selections.forEach(action => {
        let item = new DisplayInfor(action.data.Name, action.data.Id);
        const index = this.listItems.findIndex(act => act.activityDefinitionId === action.data.Id);
        if (index > -1) {
          // this.listItems.splice(index, 1);
          addAlreadyHas = true;
        }else {
          this.listItems.push(item);
        }
      });
      if(addAlreadyHas) {
        this.message.info(this.localePipe.transform('component.assignScope.duplicateNodeNoAdd'));
      }
      this.grid.loadData(this.listItems);
    }
    // 2023-6-13 关闭前清空已选数据
    this.actionsTable1.clearCheckeds(true);
    this.actionsDialog1.close();
  }

  SelectCancel() {
    // 2023-6-13 关闭前清空已选数据
    this.actionsTable1.clearCheckeds(true);
    this.actionsDialog1.close();
  }

  editConditon(e: any) {
    let context = new Array<VarEntity>();
    // if(this.expr.exprEntity.contextEntities.find(x => x.key === 'CurrentLanguage')) {
    //   context.push(this.expr.exprEntity.contextEntities.find(x => x.key === 'CurrentLanguage'));
    // }
    // this.expr.clearContext();
    if (this.uistate.schemas.length > 0) {
      for (const schema of this.uistate.schemas) {
        this.exprService.addSchema('Schema', schema);
      }
      if (this.uistate.schemas[0].entityTypes && this.uistate.schemas[0].entityTypes.length > 0) {
        const entityType = this.uistate.schemas[0].entityTypes[0];
        this.exprService.addInjectedEntity(entityType.name, 'Schema',
          entityType.name, InjectedType.EntityType);
      }
    }
    context = this.uistate.addContext(context);
    if (this.uistate.subActivityContext.length > 0) {
      for (const variable of this.uistate.subActivityContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (this.uistate.activityComponentContext.length > 0) {
      for (const variable of this.uistate.activityComponentContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (context.length > 0) {
      for (const v of context) {
        this.exprService.addContext(v);
      }
    } 
    this.exprService.setEditPattern(ExprEditMode.Conditional);   
    this.exprService.addExpressionText(e.instance.value);
    this.exprService.buildExpression().then((cond: string) => {
      e.formControl.setValue(cond);
      e.instance.cd.detectChanges();
      //点击确定后，去除表达式里面的新增的上下文变量
      if(context.length > 0) {
        this.exprService.exprEntity.contextEntities = this.exprService.exprEntity.contextEntities.filter(x => !context.some(y => y.key === x.key));
      }
    });
  }

}

export class AssignScopeConverter implements TypeConverter {
  actList = new Array();
  constructor(
    private uistate: ProcessDesignerUIState,
    private localePipe: WfLocalePipe
    ) {
    this.actList = [...this.uistate.userActList.filter(a => a.AssignmentStrategy === 'ASSIGN')];
  }

  convertTo(data): string {
    if (data && data.length > 0) {
      return this.localePipe.transform("component.assignScope.set");
    } else {
      return this.localePipe.transform("component.assignScope.notSet");
    }

  }
}
